<template>
    <div>
        <div class="introduce_wrapper clearfix hidden-xs-only" v-for="(item, idx) in synopsisList" :key="idx">
            <div class="introduce_left fl">
              <img :src="item.imageUrl" alt="">
            </div>
            <div class="introduce_right fl">
                <h1>{{item.title}}</h1>
                <!-- <p class="english_introduction">
                    Health
                    <span>Group</span>
                </p> -->
                <!-- <p class="intr_one">市卫健投公司前身为2015年8月成立的贵阳市医院管理(集团)有限公司</p> -->
                <p class="intr_two exceed_sixs_hidden" style="margin-bottom: 40px;" v-html="item.content">

                </p>
                <div class="look_more" @click="jumpSynopsisDetail">进入查看更多</div>
            </div>
        </div>
        <div class="hidden-sm-and-up introduce_phone_wrapper" v-for="(item, idx) in synopsisList" :key="idx + 1">
            <div class="content clearfix">
              <h1>{{item.title}}</h1>
              <!-- <div class="color_ash">
                Hailiang
                <span>Health</span>
              </div> -->
              <div class="introduce_one exceed_sixs_hidden" v-html="item.content">

              </div>
              <img src="../../../assets/img/intpeople.png" alt="">
              <el-button class="fr btn" size="medium" type="primary" @click="jumpSynopsisDetail">进入查看更多</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { groupInIe } from '../../../api/aboutus/aboutus'
export default {
  mounted() {
    this.getGroupInRt()
  },
  data() {
    return {
      synopsisList: []
    }
  },
  methods: {
    getGroupInRt() {
      groupInIe().then(res => {
        this.synopsisList = []
        this.synopsisList.push(res.data)
      })
    },
    jumpSynopsisDetail() {
      this.$router.push({
        path: 'synopsis',
        query: {
          titleName: "关于公司"
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/mixin.scss";
/* move */
.introduce_phone_wrapper {
    width: 100%;
    padding: 0 px2rem(10);
    box-sizing: border-box;
    margin-top: px2rem(20);
    .content {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        box-shadow: rgba(0, 0, 0, 0.247) 0px 0px px2rem(10); //将颜色提到前面，且将h-shadow,v-shadow设为0px,实现四周阴影
        border-bottom: px2rem(1) solid #ccc;
        padding-top: px2rem(20);
        padding-left: px2rem(20);
        padding-bottom: px2rem(20);
        h1 {
            font-size: px2rem(22);
            color: #3b9ed7;
            margin-bottom: px2rem(15);
        }
        .color_ash {
          font-size: px2rem(18);
          color: #b1b1b1;
          margin-bottom: px2rem(15);
          span {
            margin-left: px2rem(5);
          }
        }
        .introduce_one {
          font-size: px2rem(18);
          line-height: px2rem(26);
          color: #393939;
          margin-bottom: px2rem(15);
        }
        .introduce_two {
          font-size: px2rem(14);
          line-height: px2rem(24);
          color: #393939;
        }
        img {
          position: absolute;
          width: px2rem(100rem);
          height: px2rem(200rem);
          top: px2rem(20);
          right: 0;
          opacity: .3;
        }
        .btn {
          margin-top: px2rem(20);
          margin-right: px2rem(20);
        }
    }
}
/* pc */
.introduce_wrapper {
    width: 1147px;
    height: 281px;
    margin: 0 auto;
    margin-top: 28px;
    .introduce_left {
        width: 507px;
        height: 100%;
        border: 1px solid #d8d8d8;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
        }
    }
    .introduce_right {
        width: 638px;
        height: 100%;
        padding: 34px 25px 28px 16px;
        box-sizing: border-box;
        box-shadow: 5px 5px 5px -1px #f8f8f8, 5px -5px 5px -1px #f8f8f8;
        h1 {
            color: #3b9ed7;
            font-size: 22px;
            margin-bottom: 54px;
        }
        .english_introduction {
            font-size: 17px;
            color: #b1b1b1;
            margin-top: 15px;
            margin-bottom: 27px;
            span {
                margin-left: 8px;
            }
        }
        .intr_one {
            font-size: 17px;
            color: #393939;
            margin-bottom: 18px;
        }
        .intr_two {
            font-size: 14px;
            color: #393939;
            line-height: 17px;
            margin-bottom: 34px;
        }
        .look_more {
            width: 130px;
            height: 40px;
            line-height: 40px;
            border-radius: 18px;
            text-align: center;
            background-color: #178ccf;
            color: #fff;
            cursor: pointer;
            font-size: 12px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/components/Introduce.vue